export default class JumpOffPoint {
  constructor(id, patrolMarker, x, y) {
    this.id = id;
    this.patrolMarker = patrolMarker;
    this.x = x;
    this.y = y;
  }

  toApi() {
    return {
      id: this.id,
      patrolMarkerID: this.patrolMarker != null ? this.patrolMarker.id : null,
      x: this.x,
      y: this.y,
    };
  }

  static fromApi(obj, patrolMarkers) {
    return new JumpOffPoint(obj.id,
      obj.patrolMarkerID == null ? null : patrolMarkers.find(x=>x.id === obj.patrolMarkerID), obj.x, obj.y);
  }
}
